// extracted by mini-css-extract-plugin
module.exports = {"desktop":"LetterList_desktop__skfF9","mobile":"LetterList_mobile__Ww5RP"};